import React from "react";
import IconTooltip from "./IconTooltip";
import I18n from "i18n-js";
import {pluralize} from "../../utils/utils";

const ExpiredInvoicesAlertIcon = ({
 userId,
 expiredInvoicesCount
}) => {


  return <a href={`/users/${userId}/invoices?page=1&expired=true`}
     className="ml-2 ml-sm-4 px-0 position-relative d-block">
    <IconTooltip
      tooltipPosition={'bottom'}
      tooltipContent={`${I18n.t('js.indexInvoices.expiredInvoicesAlert_1')} ${expiredInvoicesCount} ${pluralize(expiredInvoicesCount, 'indexInvoices.expiredInvoicesAlert_2')}`}
      customComponentToRenderCssClass={'fake-class'}
      customComponentToRender={
        <React.Fragment>
          <img src="/images/icons/alert.svg" height="28" width="28"/>
          <span id="expired_invoices_container"
                className="badge bg-purple rounded-pill p-1 right--40perc-imp minW-22px">
            <small>
              {expiredInvoicesCount}
            </small>
          </span>
        </React.Fragment>
      }
    />
  </a>
};

export default ExpiredInvoicesAlertIcon;